import { cn } from '@utils/cn';

import { InformationDescription } from './InformationDescription';
import { InformationTitle } from './InformationTitle';
import { type InformationProps } from './types';

const Information = ({ className, children, ...props }: InformationProps) => {
  return (
    <div
      className={cn(
        'flex size-full flex-col items-center justify-center gap-3 p-5 text-center',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

Information.displayName = 'Information';

Information.Title = InformationTitle;
Information.Description = InformationDescription;

export { Information };
